var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 13.5 13.5",
    style: {
      enableBackground: "new 0 0 13.5 13.5"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8,6H7.5V0.8C7.5,0.3,7.2,0,6.8,0S6,0.3,6,0.8V6H0.8C0.3,6,0,6.3,0,6.8s0.3,0.8,0.8,0.8H6v5.3c0,0.4,0.3,0.8,0.8,0.8 s0.8-0.3,0.8-0.8V7.5h5.3c0.4,0,0.8-0.3,0.8-0.8S13.2,6,12.8,6z"
  })));
}

export default "data:image/svg+xml,export default 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI0LjEuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxMy41IDEzLjUiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDEzLjUgMTMuNTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBkPSJNMTIuOCw2SDcuNVYwLjhDNy41LDAuMyw3LjIsMCw2LjgsMFM2LDAuMyw2LDAuOFY2SDAuOEMwLjMsNiwwLDYuMywwLDYuOHMwLjMsMC44LDAuOCwwLjhINnY1LjNjMCwwLjQsMC4zLDAuOCwwLjgsMC44CglzMC44LTAuMywwLjgtMC44VjcuNWg1LjNjMC40LDAsMC44LTAuMywwLjgtMC44UzEzLjIsNiwxMi44LDZ6Ii8+Cjwvc3ZnPgo='";
export { SvgPlusLine as ReactComponent };